import React from "react";
import styled from "styled-components";
import { Button } from "best-common-react-3";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ImageContainer = styled.div`
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const ProfileImg = styled.img`
  width: 500px;
  height: 500px;

  @media (max-width: 976px) {
    width: 300px;
    height: 300px;
  }
`;

type ProfilePicturePreviewProps = {
  url: string;
  onDelete: () => void;
};

const ProfilePicturePreview: React.FC<ProfilePicturePreviewProps> = ({ url, onDelete }) => {
  const { t } = useTranslation("translation");

  return (
    <Container>
      <ImageContainer>
        <ProfileImg src={url} alt="Profile Picture" />
        <Button className="w-100" onClick={onDelete}>
          {t("translation:delete")}
        </Button>
      </ImageContainer>
    </Container>
  );
};

export default ProfilePicturePreview;
